<ion-app dir="{{textDir}}">
  <!-- when=false means that the split pane will never expand automatically -->
  <!-- For more info check https://ionicframework.com/docs/api/split-pane -->
  <ion-split-pane contentId="menu-content" when="false">
    <ion-menu contentId="menu-content" class="app-sidemenu">
      <ion-header><!-- Generated by Copilot -->
        <ion-toolbar color="secondary">
          <ion-row class="user-details-wrapper">
            <ion-col size="3">
              <app-aspect-ratio [ratio]="{w: 0.3, h: 0.3}">

                <app-image-shell class="user-avatar" animation="spinner" [src]="'../assets/icon/nenomed-app-logo.png'"></app-image-shell>
              </app-aspect-ratio>
            </ion-col>
            <ion-col class="user-info-wrapper" size="9">
              <h3 class="user-name title-gradient">{{getMe()?.name}} {{getMe()?.lastname}}</h3>
              <h5 class="user-handle">{{getMe()?.username}}</h5>
            </ion-col>
          </ion-row>
          <!-- <ion-row class="user-stats-wrapper user-details-wrapper">
            <ion-col size="6">
              <span class="user-stat-name">Plan: </span>
              <span class="user-stat-value">{{getMe()?.plan}}</span>
            </ion-col>
            <ion-col size="6">
              <span class="user-stat-value">{{getMe()?.userCoin.totalCoins | number:'1.0-2'}}</span>
              <span class="user-stat-name">granos</span>
            </ion-col>
          </ion-row> -->
        </ion-toolbar>
      </ion-header>
      <ion-content><!-- Generated by Copilot -->
        <ion-list>
          <ion-list-header>
            <ion-icon style="width: 30px; height: 30px;" name="rocket-outline"></ion-icon>
            <ion-label class="title-gradient" style="padding-left: 10px;">Menú Principal</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item [routerLink]="['/app/dashboard']">
              <ion-icon slot="start" name="person-outline"></ion-icon>
              <ion-label class="title-gradient">
                Dashboard
              </ion-label>
            </ion-item>
            <ion-item [routerLink]="['/app/appointments']">
              <ion-icon slot="start" name="calendar-outline"></ion-icon>
              <ion-label class="title-gradient">
                Mis Citas
              </ion-label>
            </ion-item>
            <ion-item [routerLink]="['/app/acts']">
              <ion-icon slot="start" name="pulse-outline"></ion-icon>
              <ion-label class="title-gradient">
                Mis Tratamientos
              </ion-label>
            </ion-item>
             <ion-item [routerLink]="['/app/pagos']">
              <!-- Generated by Copilot -->
              <ion-icon slot="start" name="card-outline"></ion-icon>
              <ion-label class="title-gradient">
              Mis Pagos
              </ion-label>
            </ion-item>
            <!-- Generated by Copilot -->
            <ion-item [routerLink]="['/app/patient-documents']">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>
              <ion-label class="title-gradient">
                Documentos
              </ion-label>
            </ion-item>
            <ion-item [routerLink]="['/app/messages']">
              <ion-icon slot="start" name="chatbubble-ellipses-outline"></ion-icon>
              <ion-label class="title-gradient">
                Mensajes
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        
        
       
        <ion-list>
          <ion-list-header>
            <ion-label class="title-gradient">Account</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false" *ngFor="let p of accountPages; let i = index">
            <ion-item 
              *ngIf="p.title !== 'Salir'; else logoutBtn"
              [routerLink]="p.url">
              <ion-icon slot="start" [name]="p.ionicIcon? p.ionicIcon: ''" [src]="p.customIcon? p.customIcon: ''"></ion-icon>
              <ion-label class="title-gradient">
                {{p.title}}
              </ion-label>
            </ion-item>
            <ng-template #logoutBtn>
              <ion-item (click)="confirmLogout()">
                <ion-icon slot="start" [name]="p.ionicIcon? p.ionicIcon: ''" [src]="p.customIcon? p.customIcon: ''"></ion-icon>
                <ion-label class="title-gradient">
                  {{p.title}}
                </ion-label>
              </ion-item>
            </ng-template>
          </ion-menu-toggle>
          <ion-menu-toggle autoHide="false">
            <!-- <ion-item (click)="openTutorial()"> -->
            <ion-item >
              <ion-icon slot="start" name="school-outline"></ion-icon>
              <ion-label class="title-gradient">
                Tutorial
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <!-- <ion-list>
          <ion-list-header>
            <ion-label>Showcase</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item [routerLink]="['/showcase/app-shell']">
              <ion-icon slot="start" name="egg-outline"></ion-icon>
              <ion-label>
                App Shell
              </ion-label>
            </ion-item>
            <ion-item [routerLink]="['/showcase/route-resolvers-ux']">
              <ion-icon slot="start" name="cog-outline"></ion-icon>
              <ion-label>
                Route Resolvers UX
              </ion-label>
            </ion-item>
            <ion-item [routerLink]="['/showcase/custom-components']">
              <ion-icon slot="start" name="color-wand-outline"></ion-icon>
              <ion-label>
                Custom Components
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list> -->
      </ion-content>
    </ion-menu>
    <!-- Main app content gets rendered in this router-outlet -->
    <ion-router-outlet id="menu-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
